import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
}

@Component({
  selector: 'infobox',
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './infobox.component.html',
  styleUrl: './infobox.component.scss'
})
export class InfoboxComponent {
  readonly dialogRef = inject(MatDialogRef<InfoboxComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  OkClick(): void {
    this.dialogRef.close(true);
  }
}
